import React, { KeyboardEvent, MouseEvent, useRef } from "react";
import styles from "./blueprint-description-popover.module.scss";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import { HorizontalSeparator } from "@src/components/atoms/horizontal-separator/horizontal-separator";
import { GradientBorderContainer } from "@src/components/templates/layouts/gradient-border-container/gradient-border-container";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import closeIconGray from "@src/assets/svg/close-icon-gray.svg";
import { useClickOutsideListener } from "@src/hooks/use-click-outside-listener";
import { useI18N } from "@src/language/language-context";

const cssClassName = "blueprint-description-popover";

interface BlueprintDescriptionPopoverPropTypes {
  blueprint: BlueprintsArrayObjectTypes;
  renderPosition: { x: number; y: number };
  handleClosePopover: (e: MouseEvent | KeyboardEvent) => void;
}

export const BlueprintDescriptionPopover = ({
  blueprint,
  renderPosition,
  handleClosePopover,
}: BlueprintDescriptionPopoverPropTypes) => {
  const popoverRef = useRef<HTMLDivElement>(null);
  const i18n = useI18N();

  const texts = {
    descriptionAuthor: i18n(
      "modules.blueprintDescriptionPopover.descriptionAuthor",
    ),
  };

  useClickOutsideListener(popoverRef, handleClosePopover, true);

  return (
    <div
      className={styles[cssClassName]}
      style={{
        top: `${renderPosition.y}px`,
        left: `${renderPosition.x}px`,
      }}
      ref={popoverRef}
    >
      <GradientBorderContainer>
        <div className={styles[`${cssClassName}__inner-wrapper`]}>
          <div className={styles[`${cssClassName}__upper-wrapper`]}>
            <p className={styles[`${cssClassName}__upper-text`]}>
              {`${texts.descriptionAuthor} ${blueprint.author}`}
            </p>
            <IconButton fun={handleClosePopover} icon={closeIconGray} />
          </div>
          <HorizontalSeparator />
          <div className={styles[`${cssClassName}__lower-wrapper`]}>
            <p className={styles[`${cssClassName}__lower-text`]}>
              {blueprint.description}
            </p>
          </div>
        </div>
      </GradientBorderContainer>
    </div>
  );
};
